import { Tab, TabProps, Box } from '@mui/material';
import classNames from 'classnames/bind';
import styles from './BaseTab.module.scss'

type BaseTabProps = TabProps

const cx = classNames.bind(styles);

const BaseTab = (props: BaseTabProps) => {

  return (
    <Box className={cx("tab-item-container")}>
      <Tab {...props}>
        {props.children}
      </Tab>
    </Box>
  )
}

export default BaseTab
